import Component from "~/components/component";

export default class socialNetworks extends Component {
	constructor(...args) {
		super(...args);

		this._blocks = Array.from(
			this.dom.component.querySelectorAll(".social-block")
		).map((block) => new SocialNetworksBlock(block));
	}

	bind() {
		this._blocks.forEach((block) => block.bind());
	}

	unbind() {
		this._blocks.forEach((block) => block.unbind());
	}
}

class SocialNetworksBlock extends Component {
	constructor(...args) {
		super(...args);

		this._countrySelect =
			this.dom.component.querySelector(".js-select-country");

		this._socialNetworks = Array.from(
			this.dom.component.querySelectorAll(".social-networks li")
		).map((element) => {
			const link = element.querySelector("a");
			const variations = Array.from(
				element.querySelectorAll("input[type=hidden]")
			).map((variation) => ({ id: variation.name, value: variation.value }));
			return { element, link, variations };
		});
	}

	_onCountrySelectChange = (e) => {
		this._socialNetworks.forEach((socialNetwork) => {
			const variation = socialNetwork.variations.find(
				(v) => v.id === e.detail.value
			);
			if (variation) socialNetwork.link.href = variation.value;
		});
	};

	bind() {
		if (this._countrySelect) {
			this._countrySelect.addEventListener(
				"onChange",
				this._onCountrySelectChange
			);
		}
	}

	unbind() {
		if (this._countrySelect) {
			this._countrySelect.removeEventListener(
				"onChange",
				this._onCountrySelectChange
			);
		}
	}
}



// WEBPACK FOOTER //
// src/js/components/social-networks/social-networks.js